import { encodePeriodValue } from '@components'

import { getPeriodValueFromFiscalYear } from '../../../utils/getPeriodValueFromFiscalYear'

interface GetDefaultReportPeriodParams {
  fiscalYear?: number
  organizationId?: string
}

/**
 * Default period shown before the URL or the user picks one: the organization's current fiscal year. Needs the
 * organization's id and current fiscal year, so it returns an empty string until both have loaded (callers treat an
 * empty period as "not ready yet").
 */
export const getDefaultReportPeriod = ({ fiscalYear, organizationId }: GetDefaultReportPeriodParams): string => {
  if (!organizationId || fiscalYear === undefined) {
    return ''
  }

  return encodePeriodValue(getPeriodValueFromFiscalYear(fiscalYear), organizationId) ?? ''
}
